'use strict';

/**
 * Инициализация плагина Magnific Popup
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import 'magnific-popup';
import merge from 'lodash/merge';
import validation from './validation';
import horizontalScroll from './horizontal-scroll';
import wrapMedia from './wrap-media';

// ----------------------------------------
// Private
// ----------------------------------------

// переводы для плагина
(function ($, jsTranslations = {}) {
	let {mfp} = jsTranslations;
	if (!mfp) {
		return false;
	}

	$.extend(true, $.magnificPopup.defaults, {
		tClose: mfp.tClose,
		tLoading: mfp.tLoading,
		gallery: {
			tPrev: mfp.tPrev,
			tNext: mfp.tNext,
			tCounter: mfp.tCounter
		},
		image: {
			tError: mfp.tErrorImage
		},
		ajax: {
			tError: mfp.tError
		},
		inline: {
			tNotFound: mfp.tNotFound
		}
	});
})(window.jQuery, window.jsTranslations);

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-form"]- поиск элементов по селектору
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @param {jQuery} [$wrapper=$('body')] - контекст в котором будет выполнен поиск селектора
 * @sourceCode
 */
function mfpAjax (selector = '.js-mfp-ajax', userConfig = {}, $wrapper = $('body')) {
	const config = merge({
		mainClass: 'zoom-in',
		type: 'ajax',
		delegate: selector,
		removalDelay: 200,
		autoFocusLast: false,
		fixedContentPos: false,
		callbacks: {
			elementParse (item) {
				let {
					url,
					type = 'POST',
					param: data = {}
				} = item.el.data();
				this.st.ajax.settings = {url, type, data};
			},
			ajaxContentAdded () {
				let btn = this.currItem.el;
				let $container = this.contentContainer || [];
				if ($container) {
					horizontalScroll('.wysiwyg table', $container);
					wrapMedia('.wysiwyg iframe, .wysiwyg video', $container);
					validation('.js-form', $container);
				}

				if (typeof btn.data('order-name') !== 'undefined') {
					$container.find('.js-order-name').html(btn.data('order-name'));
				}

				let setNumber = $('.js-set-number');

				if (setNumber.length) {
					let number = $('#get-number').text();
					setNumber.text(number);
					number = number.replace(/ /g, '');
					setNumber.attr('href', 'tel:+38' + number);
				}

				(function () {
					let select = $container.find('#wycena-service');
					let active = btn.data('active');

					if (select.length && typeof active !== 'undefined') {
						select.find(`option[value="${active}"]`).attr('selected', true);
					}
				}());
			}
		}
	}, userConfig);

	$wrapper.magnificPopup(config);
}

function mfpIframe (selector = '.js-mfp-iframe', userConfig = {}, $wrapper = $('body')) {
	const config = merge({
		mainClass: 'zoom-in',
		type: 'iframe',
		closeBtnInside: true,
		autoFocusLast: false,
		fixedContentPos: false,
		removalDelay: 200,
		iframe: {
			markup: '<div class="magnific-popup mfp-iframe-scaler">' +
			'<div class="mfp-close"></div>' +
			'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
			'</div>'
		}
	}, userConfig);

	$(selector).magnificPopup(config);
}

function mfpInline (selector = '.js-mfp-inline', userConfig = {}) {
	const config = merge({
		mainClass: 'zoom-in',
		type: 'inline',
		closeBtnInside: true,
		autoFocusLast: false,
		fixedContentPos: false,
		removalDelay: 200,
		callbacks: {
			open: function() {
				$('body').addClass('oh');
			},
			close: function() {
				$('body').removeClass('oh');
			}
		}
	}, userConfig);

	$(selector).magnificPopup(config);
}

function mfpImage (selector = '.js-mfp-image', userConfig = {}) {
	const config = merge({
		mainClass: 'zoom-in',
		type: 'image',
		gallery:{
			enabled:true
		},
		closeBtnInside: true,
		autoFocusLast: false,
		fixedContentPos: false,
		removalDelay: 200
	}, userConfig);

	$(selector).magnificPopup(config);
}



// ----------------------------------------
// Exports
// ----------------------------------------

export { mfpAjax, mfpIframe, mfpInline, mfpImage };



// WEBPACK FOOTER //
// ./src/js/_modules/magnific-popup.js